import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCustomization from './reducers';

export const selectLanguageState =
  createFeatureSelector<fromCustomization.Customization>(
    fromCustomization.customizationFeatureKey
  );

export const selectCurrentCustomizationState = createSelector(
  selectLanguageState,
  (state: fromCustomization.Customization) => state
);
